import React from 'react';
import AprovalHistoryCard from './components/AprovalHistoryIndex.jsx';

const AprovalHistory = () => <AprovalHistoryCard />;

export default AprovalHistory;
